/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

/* Styles */
import './LanderTitle.scss';

function LanderTitle({
  className = '',
  small = false,
}) {
  return (
    <div
      className={`dtv-html5-c-lander-title ${
        small ? 'dtv-html5-c-lander-title--small' : ''
      } ${className}`}
    >
      <h1 className="dtv-html5-c-lander-title__text">
        <FormattedMessage id="myPage.title" />
      </h1>
    </div>
  );
}

LanderTitle.propTypes = {
  className: PropTypes.string,
  small: PropTypes.bool,
};

export default memo(LanderTitle);
